import React, {useRef, useState, useEffect} from 'react'
import icon from '../logo.png'
import { useHistory } from 'react-router-dom';
import { showToast } from '../../../Component/Toast';
import Button from '../../../Component/Button'
import axios from 'axios';
import useClientHook from "../../../Hooks/useClientHook";
import Spinner from '../../../Component/Loader'

export default function Render() {

	let HISTORY = useHistory();
	let EMAIl = useRef(null);

	const [BtnLoader, setBtnLoader] = useState(false);
	const [LoginMessage, setLoginMessage] = useState();
	const [LoginField, setLoginField] = useState();

	let params = new URLSearchParams(window.location.search)
	let {client_id, origin, logo} = useClientHook('USER')

	useEffect(() => {
		if (params.get('success') === 'false') {
			setLoginMessage(new URLSearchParams(window.location.search).get('message'))
		}
	}, [params]);

	const sendOTP = () => {
		let email = EMAIl.current.value;

		if (!email) {
			showToast({
				type: 'error',
				message: 'Enter Email Address'
			})
			return;
		}
		email = email.trim()

		setBtnLoader(true)
		axios.post(`https://auth.dice.tech/auth/personal/username`, {email,client_id}).then((res,err) => {
			setBtnLoader(false)
			HISTORY.push(`/personal/verify?email=${email}&origin=${origin}`)

		}).catch(err => {
			setBtnLoader(false)
			if(err.response&&err.response.data.message==='User not found'){
				showToast({
					type: 'error',
					message: 'Please create an account first'
				})
				HISTORY.push(`/personal/new/?origin=${origin}`)
			}else{
				showToast({
					type: 'error',
					message: err.response ? err.response.data.message : "Something went wrong !"
				})
			}
		})
	}

	if(!client_id){
		return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background: '#fff'}}><Spinner/></div>
	}

	return (
		<div className="bg-white d-flex align-items-center overflow-hidden" style={{height:'100vh',textTransform: 'none'}}>
			<div className='text-center w-100 p-4'  style={{maxWidth: 350, margin: 'auto'}}>
				<div className='mb-4'>
					<img alt='Logo' className="mb-1" src={logo} style={{maxWidth: 70}} />
				</div>
				<p>Enter your Login details to continue</p>
				{
					LoginField&&
					<div className="mt-4 mb-2 text-start">
						<input ref={EMAIl} type="text" className="form-control mb-2" placeholder="Email Address" />
					</div>
				}
				{
					LoginMessage ?
					<p className='text-danger text-left' style={{fontSize: '0.8rem', textAlign: 'left'}}>
						<svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg>
						{LoginMessage}
					</p>
					: <></>
				}
				{
					LoginField?
					<Button onClick={()=>{sendOTP()}} name='Get OTP' loading={BtnLoader}/>:
					<Button onClick={()=>{setLoginField(true)}} name='Login'/>
				}
				<button onClick={()=>HISTORY.push(`/personal/new/?origin=${origin}`)} className="btn w-100 btn-outline-dark mt-3 p-2" x="button" style={{borderWidth: 2}}>Create Account</button>

				{
					origin?
						<div className='position-relative pt-3' style={{borderTop:'1px solid #000', marginTop:'4rem'}}>
							<button onClick={()=>HISTORY.push(`/?origin=${origin}`)} className="btn w-100 btn-light border mt-3 p-2" x="button" style={{borderWidth: 2}}><img alt='Logo' className="me-4 mb-1" src={icon} style={{maxWidth: 20}} />Log in with Dice</button>
							<div className='position-absolute bg-white ps-3 pe-3' style={{fontSize:'0.8rem', top:'-10px', left:'50%', transform: 'translateX(-50%)'}}>
								SSO Login
							</div>
						</div>:undefined
				}
			</div>
		</div>
	)
}
